import React, { lazy, Suspense, useState, useEffect } from "react";
import "./App.css";
import Home from "./component/Home/Home";
import { Route, Routes } from "react-router-dom";
import Client from "./component/Partners";
import News from "../src/component/News/index";
import Quotes from "./component/Quotes";
import ContactUs from "./component/ContactUs";
import Oppo from "./component/News/InnerPages/Oppo";
import HanayaOoredoo from "./component/News/InnerPages/HanayaOoredoo";
import LgElectronic from "./component/News/InnerPages/LgElectronic";
import EmirateTrip from "./component/News/InnerPages/EmirateTrip";
import JoinUsInner from "./component/JoinUsInner";
import CocoCola from "./component/News/InnerPages/CocoCola";
import HuaweiPrime from "./component/News/InnerPages/HuaweiPrime";
import Agency from "./component/Agency/index";
import Team from "./component/Team/index";
import Work from "./component/Work/index";
import ServicesMain from "./component/Services/ServicesMain";
import OurServices from "./component/Services/OurServices";
import CockStudio from "./component/News/InnerPages/CockStudio";
function App() {

  const [language, setLanguage] = useState(() => {
    return Number(localStorage.getItem("language")) || 1;
  });

  useEffect(() => {
    const rtlLanguages = [3];
    const dir = rtlLanguages.includes(language) ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguageChange = (e) => {
    setLanguage(Number(e.target.value));
  };

  console.log("date=07/05/2025, time=02:10");
  // const { t } = useTranslation();
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agency" element={<Agency />} />
        <Route path="/client" element={<Client />} />
        <Route path="/news" element={<News />} />
        <Route path="/team" element={<Team />} />
        <Route path="/work" element={<Work />} />
        <Route path="/quote" element={<Quotes />} />
        <Route path="/join_inner" element={<JoinUsInner />} />
        <Route path="/services" element={<ServicesMain />} />
        <Route path="/our-services" element={<OurServices />} />
        {/* <Route path="/services" element={<Services/>}/> */}
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/cock_studio" element={<CockStudio />} />
        <Route path="/oppo" element={<Oppo />} />
        <Route path="/hanaya" element={<HanayaOoredoo />} />
        <Route path="/lg_electronic" element={<LgElectronic />} />
        <Route path="/emirate_trip" element={<EmirateTrip />} />
        <Route path="/news_cococola" element={<CocoCola />} />
        <Route path="/news_huawei" element={<HuaweiPrime />} />
      </Routes>
    </div>
  );
}
export default App;
